import { applyTableStateParams, getTableState, getTableStateParams } from './get-table-state'
import { tableConfig } from './table-config'
import { HeadlessTableClientState, HeadlessTableConfig } from './types'
import { useTable } from './use-table'
import { HeadlessTableContext } from './headless-table-context'
import {
  HeadlessTableSearchForm,
  HeadlessTableSearchInput,
  useHeadlessTableClearAll,
  useHeadlessTableLink
} from './use-table-link'
import React from 'react'

export * from './types'

function HeadlessTableRoot<C extends HeadlessTableConfig<any, any, any, any>>({
  state,
  children
}: {
  state: HeadlessTableClientState<C>
  children?: React.ReactNode
}) {
  return <HeadlessTableContext.Provider value={state}>{children}</HeadlessTableContext.Provider>
}

export const HeadlessTable = Object.assign(HeadlessTableRoot, {
  config: tableConfig,
  getParams: getTableStateParams,
  getState: getTableState,
  useTable: useTable,
  applyTableStateParams: applyTableStateParams,
  SearchForm: HeadlessTableSearchForm,
  SearchInput: HeadlessTableSearchInput,
  useTableLink: useHeadlessTableLink,
  useClearAll: useHeadlessTableClearAll,
  useTableContext: () => React.useContext(HeadlessTableContext)
})
